import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { AssetsThunkDispatch } from '../../features/app/actions/assets/types';
import type { AppDispatch, RootState } from './store';

// https://redux.js.org/usage/usage-with-typescript#define-typed-hooks
// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAssetsThunkDispatch = () => useDispatch<AssetsThunkDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
